import { ref, watch } from 'vue'
import { useLocalStorage } from '@vueuse/core'

export interface CommandHistoryItem {
  id: string
  name: string
  description: string
  icon?: string
  to?: string
  action?: () => void
  timestamp: number
}

export function useCommandHistory(maxItems = 5) {
  const history = useLocalStorage<CommandHistoryItem[]>(
    'command-palette-history',
    [],
  )

  function addToHistory(item: Omit<CommandHistoryItem, 'timestamp'>) {
    // Remove existing entry if present
    const existingIndex = history.value.findIndex((h) => h.id === item.id)
    if (existingIndex !== -1) {
      history.value.splice(existingIndex, 1)
    }

    // Add new entry at the beginning
    history.value.unshift({
      ...item,
      timestamp: Date.now(),
    })

    // Keep only the most recent items
    if (history.value.length > maxItems) {
      history.value = history.value.slice(0, maxItems)
    }
  }

  function clearHistory() {
    history.value = []
  }

  return {
    history,
    addToHistory,
    clearHistory,
  }
}
